import type { ElementType } from 'react';
import { NotificationOutlined } from '@ant-design/icons';
import { findMenuItem } from 'menu-items/catalog';
import type { Post } from './types';

/** What's new's own icon, a megaphone: the header button, the Support menu item and posts without one of their own. */
export const WHATS_NEW_ICON: ElementType = NotificationOutlined;

/** The icon a post is shown with: its own, its menu item's, or What's new's. */
export const postIcon = (post: Post): ElementType =>
  post.icon ?? (post.menuItemId ? findMenuItem(post.menuItemId)?.icon : undefined) ?? WHATS_NEW_ICON;
